import { useEffect } from "react";
import { cmsBaseUrl } from "../config/GlobalConfig";

export default function Error404Page() {
    useEffect(() => {
        console.log(process.env.REACT_APP_ENV_MODE);
        if(process.env.REACT_APP_ENV_MODE && process.env.REACT_APP_ENV_MODE === 'local') {
            window.location.href = process.env.REACT_APP_RESSOURCE_BASE_URL + "/local/start.html";
            // window.location.href = process.env.REACT_APP_LOGIN_BASE_URL!;
        }
      }, []);
     


    return (
        <section className="p-y-lg bg-glace">
            <div className="grid">
                <div className="col-start-1 col-end-4 col-sm-end-7 col-lg-start-2 col-lg-end-12">
                    <article className="post bg-blanc p-y-lg">
                        <header className="post--header">
                            <h1 className="page-title mb-md ">404 - Page introuvable</h1>
                        </header>
                        <main className="post--main">
                            <p className="text">Le fichier que vous avez demandé est introuvable sur ce serveur.</p>
                        </main>
                        <footer className="mt-lg ta-center">
                            <ul className="post--share mb-sm">
                            </ul>
                            <a href={cmsBaseUrl} className="cta-bleu">Page d'accueil</a>
                        </footer>
                    </article>
                </div>
            </div>
        </section>
    )

}